export const APP_DNEVNIK = 'dnevnik' as const
export const APP_CAFETERIA = 'cafeteria' as const
export const APP_ACCESS = 'access' as const
export const APP_POLLS = 'polls' as const
export const EXT_ELJUR = 'eljur' as const
export const EXT_CUSTOM = 'custom' as const
export const EXT_YACLASS = 'yaklass' as const
